<template>
  <div class="mt-3 p-2">
    <b-container fluid class="mb-2">
      <b-row class="mb-2">
        <b-col>
          <h5 class="text-uppercase heading">Announcement</h5>
        </b-col>
        <b-col class="text-right">
          <social-media-create @socialMediaCreateEvent="fetchData"></social-media-create>
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col md="2">
          <!-- Select User Per Page  -->
          <b-form-select v-model="item_per_page" @change="changeItemNumber">
            <b-form-select-option value="10">10</b-form-select-option>
            <b-form-select-option value="50">50</b-form-select-option>
            <b-form-select-option value="100">100</b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col md="10">
          <!-- Filter -->
          <b-form-group label="" label-for="filter-input" class="mb-0">
            <b-input-group>
              <b-form-input id="filter-input" v-model="filter" type="search"
                placeholder="Type to Search"></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-tabs content-class="mt-3" v-model="activeTab">
        <b-tab title="Announcements" active>
          <div class="mb-3 d-flex justify-content-end">
            <b-button variant="success" @click="downloadAnnouncementsCSV">
              <i class="fa fa-download" aria-hidden="true"></i>
            </b-button>
          </div>

          <b-table class="dataTable rounded-left" :outlined="true" :items="items" :fields="fields" :filter="filter"
            @filtered="filtered" :sort-desc.sync="sortDesc" head-variant="none" table-variant="none" :busy="isBusy">
            <template #cell(#)="data">
              <span v-if="currentPage == 1">{{ data.index + 1 }}</span>
              <span v-else>{{
                (currentPage - 1) * item_per_page + (data.index + 1)
              }}</span>
            </template>
            <template #cell(image)="row">
              <img :src="row.item.image" class="rounded" width="50px" height="50px" />
            </template>
            <template #cell(assignmentLevel)="row">
              <span v-if="row.item.assignmentLevel === 'project_level'">Project Level</span>
              <span v-else-if="row.item.assignmentLevel === 'zone_level'">Zone Level</span>
              <span v-else-if="row.item.assignmentLevel === 'plot_level'">Plot Level</span>
              <span v-else-if="row.item.assignmentLevel === 'general'">General</span>
            </template>
            <template #cell(url)="row">
              <a :href="'/announcement/' + row.item._id" target="__blank">{{
                row.item.title
              }}</a>
            </template>
            <template #cell(likes)="data">
              <i class="fas fa-heart text-danger"></i>

              <span v-if="data.item.likes">
                {{ data.item.likes }}
              </span>
              <span v-else>
                0
              </span>
            </template>
            <template #cell(comments)="data">
              <i class="fas fa-comment text-success"></i>
              <span v-if="data.item.comments">
                {{ data.item.comments }}
              </span>
              <span v-else>
                0
              </span>
            </template>

            <template #cell(actions)="row">
              <b-dropdown size="sm" id="dropdown-1" text="Actions" variant="primary">
                <b-dropdown-item>
                  <router-link :to="'/announcement/' + row.item.announcementId"
                    style="text-decoration: none; color: #000">
                    View
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <div @click="deleteAnnouncement(row.item.announcementId)">
                    Delete
                  </div>
                </b-dropdown-item>
                <b-dropdown-item>
                  <router-link :to="'/announcement/' + row.item.announcementId + '/edit'"
                    style="text-decoration: none; color: #000">Edit
                  </router-link>
                </b-dropdown-item>
              </b-dropdown>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-tab>




        <b-tab title="Comments Overview">
          <b-table class="dataTable rounded-left" :outlined="true" :items="commentsItems" :fields="commentsFields"
            :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" head-variant="none"
            table-variant="none" :busy="isBusy">
            <template #cell(#)="data">
              <span v-if="currentPage == 1">{{ data.index + 1 }}</span>
              <span v-else>{{
                (currentPage - 1) * item_per_page + (data.index + 1)
              }}</span>
            </template>

            <template #cell(created_ts)="data">
              {{ data.item.created_ts | moment('DD-MM-YYYY hh:mm:ss A') }}
            </template>
            <template #cell(comments)="data">
              <i class="fas fa-comment text-success"></i>
              {{ data.item.comments }}
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-tab>

        <b-tab title="Likes Overview">
          <b-table class="dataTable rounded-left" :outlined="true" :items="likesItems" :fields="likesFields"
            :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" head-variant="none"
            table-variant="none" :busy="isBusy">
            <template #cell(#)="data">
              <span v-if="currentPage == 1">{{ data.index + 1 }}</span>
              <span v-else>{{
                (currentPage - 1) * item_per_page + (data.index + 1)
              }}</span>
            </template>

            <template #cell(created_ts)="data">
              {{ data.item.created_ts | moment('DD-MM-YYYY hh:mm:ss A') }}
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-tab>

        <b-tab title="Banners">
          <div class="mb-3">
            <banner-create-modal :editBanner="editingBanner" @bannerSaved="fetchBanners"
              @resetEdit="editingBanner = null" />
          </div>


          <div v-if="!bannerIsBusy && banners.length > 0">
            <b-row>
              <b-col v-for="banner in banners" :key="banner._id" cols="12" md="6" lg="4" class="mb-4">
                <b-card class="banner-card h-100">

                  <div class="banner-image-container">
                    <img :src="banner.image" :alt="banner.name || 'Banner'" class="banner-image" />

                    <b-badge :variant="banner.bannerType === 1 ? 'primary' : 'info'" class="banner-type-badge">
                      {{ banner.bannerType === 1 ? 'Quote Banner' : 'Image Banner' }}
                    </b-badge>

                    <b-badge :variant="banner.active ? 'success' : 'secondary'" class="banner-status-badge">
                      {{ banner.active ? 'Active' : 'Inactive' }}
                    </b-badge>
                  </div>


                  <b-card-body class="banner-content">

                    <div v-if="banner.bannerType === 1">
                      <h6 class="banner-author">{{ banner.name }}</h6>
                      <p class="banner-designation text-muted">{{ banner.designation }}</p>
                      <p class="banner-quote">{{ banner.quote }}</p>
                    </div>


                    <div v-else>
                      <h6 class="text-center">Image Banner</h6>
                      <p v-if="banner.url" class="banner-url">
                        <i class="fas fa-link"></i>
                        <a :href="banner.url" target="_blank" class="text-truncate d-inline-block"
                          style="max-width: 200px;">
                          {{ banner.url }}
                        </a>
                      </p>
                      <p v-else class="text-muted text-center">No redirect URL</p>
                    </div>


                    <div class="banner-actions mt-3 d-flex justify-content-end">
                      <b-button size="sm" variant="outline-primary" class="mr-2" @click="editBanner(banner)">
                        <i class="fas fa-edit"></i>
                      </b-button>
                      <b-button size="sm" variant="outline-danger" @click="deleteBanner(banner)">
                        <i class="fas fa-trash"></i>
                      </b-button>
                    </div>
                  </b-card-body>


                  <b-card-footer class="text-muted small">
                    Created: {{ banner.createdAt | moment('DD-MM-YYYY') }}
                  </b-card-footer>
                </b-card>
              </b-col>
            </b-row>
          </div>


          <div v-else-if="!bannerIsBusy && banners.length === 0" class="text-center py-5">
            <i class="fas fa-image fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">No banners found</h5>
            <p class="text-muted">Create your first banner to get started</p>
          </div>


          <div v-else-if="bannerIsBusy" class="text-center py-5">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading banners...</strong>
          </div>
        </b-tab>
      </b-tabs>

      <div class="d-flex justify-content-center mt-4">
        <b-pagination pills v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
          aria-controls="my-table"></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import socialMediaCreate from '@/components/social-media/create';
import BannerCreateModal from '@/components/social-media/banner/create';

export default {
  name: 'Users',
  components: {
    socialMediaCreate,
    BannerCreateModal,
  },
  data() {
    return {
      item_per_page: 10,
      activeTab: 0,
      announcementsCurrentPage: 1,
      announcementsPerPage: 10,
      announcementsRows: 0,
      commentCurrentPage: 1,
      commentPerPage: 10,
      commentsRows: 0,
      likesPerPage: 10,
      likesRows: 0,
      likesCurrentPage: 1,
      sortDesc: false,
      filter: null,
      announcementsIsBusy: false,
      isBusyComments: false,
      isBusyLikes: false,
      bannerIsBusy: false,
      items: [],
      downloadItems: [],
      commentsItems: [],
      likesItems: [],
      banners: [],
      editingBanner: null,
      fields: [
        '#',
        {
          key: 'image',
          label: 'Cover Image',
        },
        {
          key: 'title',
          label: 'Title',
          sortable: true,
        },
        {
          key: 'likes',
          label: 'Likes',
          sortable: true,
        },
        {
          key: 'comments',
          label: 'Comments',
          sortable: true,
        },
        {
          key: 'assignmentLevel',
          label: 'Assignment Level',
          sortable: true,
        },
        'actions',
      ],
      commentsFields: [
        '#',
        {
          key: '_announcement_id.title',
          label: 'Announcement',
        },
        {
          key: '_user_id.name',
          label: 'User Name',
        },
        {
          key: 'comment',
          label: 'Comment',
        },
        {
          key: 'created_ts',
          label: 'Time',
          sortable: true,
        },
        {
          key: 'admin_comment.comment',
          label: 'Admin Reply',
          formatter: (value) => {
            if (value) return 1;
            else return 0;
          },
          sortable: true,
        },
      ],
      likesFields: [
        '#',
        {
          key: '_announcement_id.title',
          label: 'Announcement',
        },
        {
          key: '_user_id.name',
          label: 'User Name',
        },
        {
          key: 'created_ts',
          label: 'Time',
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
    this.fetchComments();
    this.fetchLikes();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    currentItems() {
      switch (this.activeTab) {
        case 0: return this.items;
        case 1: return this.banners;
        case 2: return this.commentsItems;
        case 3: return this.likesItems;
        default: return [];
      }
    },
    currentPage: {
      get() {
        switch (this.activeTab) {
          case 0: return this.announcementsCurrentPage;
          case 2: return this.commentCurrentPage;
          case 3: return this.likesCurrentPage;
          default: return 1;
        }
      },
      set(value) {
        switch (this.activeTab) {
          case 0: this.announcementsCurrentPage = value; break;
          case 2: this.commentCurrentPage = value; break;
          case 3: this.likesCurrentPage = value; break;
        }
      }
    },
    totalRows() {
      switch (this.activeTab) {
        case 0: return this.announcementsRows;
        case 1: return this.banners.length;
        case 2: return this.commentsRows;
        case 3: return this.likesRows;
        default: return 0;
      }
    },
    perPage() {
      switch (this.activeTab) {
        case 0: return this.announcementsPerPage;
        case 1: return this.banners.length;
        case 2: return this.commentPerPage;
        case 3: return this.likesPerPage;
        default: return 10;
      }
    },
    isBusy() {
      switch (this.activeTab) {
        case 0: return this.announcementsIsBusy;
        case 1: return this.bannerIsBusy;
        case 2: return this.isBusyComments;
        case 3: return this.isBusyLikes;
        default: return false;
      }
    }
  },
  watch: {
    currentPage(newPage) {
      switch (this.activeTab) {
        case 0:
          this.fetchData(newPage);
          break;
        case 1:
        case 2:
        case 3:
          break;
      }
    },
    activeTab(newTab) {
      switch (newTab) {
        case 0:
          if (this.items.length === 0) {
            this.fetchData();
          }
          break;
        case 3:
          if (this.banners.length === 0) {
            this.fetchBanners();
          }
          break;
        case 1:
          if (this.commentsItems.length === 0) {
            this.fetchComments();
          }
          break;
        case 2:
          if (this.likesItems.length === 0) {
            this.fetchLikes();
          }
          break;
      }
    }
  },
  methods: {
    filtered(filteredItems) {
      this.downloadItems = filteredItems;
    },

    changeItemNumber() {
      this.perPage = this.item_per_page;
    },

    fetchBanners() {
      this.bannerIsBusy = true;
      this.$apiV2.get('announcement-banner')
        .then((resp) => {
          if (resp.data.success) {
            this.banners = resp.data.data;
          }
        })
        .catch((error) => {
          this.$toast.error('Failed to fetch banners');
          console.error('Error fetching banners:', error);
        })
        .finally(() => {
          this.bannerIsBusy = false;
        });
    },

    editBanner(banner) {
      this.editingBanner = { ...banner };
    },

    deleteBanner(banner) {
      this.$bvModal.msgBoxConfirm(
        `Are you sure you want to delete this banner?`,
        {
          title: 'Confirm Delete',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
        .then(confirmed => {
          if (confirmed) {
            this.$apiV2.delete(`announcement-banner/${banner._id}`)
              .then((resp) => {
                if (resp.data.success) {
                  this.$bvToast.toast('Banner deleted successfully', {
                    title: 'Success',
                    variant: 'success',
                    solid: true
                  });
                  this.fetchBanners(); 
                } else {
                  this.$bvToast.toast('Failed to delete banner', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                  });
                }
              })
              .catch((error) => {
                this.$bvToast.toast('Error deleting banner', {
                  title: 'Error',
                  variant: 'danger',
                  solid: true
                });
                console.error('Error deleting banner:', error);
              });
          }
        })
        .catch(err => {
          this.$bvToast.toast('Error deleting banner', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
          console.error('Error deleting banner:', err);
        });
    },

    fetchLikes() {
      this.isBusyLikes = true;
      window.axios.get('likes').then((resp) => {
        if (resp.data.success) {
          this.likesItems = resp.data.likes;
          this.likesRows = resp.data.likes.length;
        }
      }).finally(() => {
        this.isBusyLikes = false;
      });
    },

    fetchComments() {
      this.isBusyComments = true;
      window.axios.get('comments').then((resp) => {
        if (resp.data.success) {
          this.commentsItems = resp.data.data;
          this.commentsRows = resp.data.data.length;
        }
      }).finally(() => {
        this.isBusyComments = false;
      });
    },

    fetchData(page = 1) {
      this.announcementsIsBusy = true;
      this.$apiV2.get('announcements', {
        params: { page, limit: this.announcementsPerPage }
      }).then((resp) => {
        if (resp.data.success) {
          this.$set(this, 'items', resp.data.data.data);
          const pagination = resp.data.data.pagination;
          this.announcementsRows = pagination.total;
          this.announcementsCurrentPage = pagination.currentPage;
        }
      }).finally(() => {
        this.announcementsIsBusy = false;
      });
    },

    deleteAnnouncement(id) {
      let prompt = confirm('Are you sure want to delete ? ');
      if (prompt) {
        this.$apiV2.delete('announcements/' + id).then(() => {
          this.fetchData();
        });
      }
    },

    downloadAnnouncementsCSV() {
      let csv = '\ufeff' + 'TITLE,LIKES,COMMENTS,ASSIGNMENT LEVEL\n';
      this.downloadItems.forEach((el) => {
        let likes = el['likes'].length;
        let comments = el['comments'].length;
        var line =
          el['title'] +
          ',' +
          likes +
          ',' +
          comments +
          ',' +
          el['assignment_level'] +
          '\n';
        csv += line;
      });
      var blob = new Blob([csv], { type: 'csv/plain' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Announcements.csv';
      link.click();
    },

    downloadCommentsCSV() {
      let csv =
        '\ufeff' + 'ANNOUNCEMENT,USER NAME, COMMENT, TIME, ADMIN REPLY\n';
      this.items.forEach((el) => {
        let adminReply = el['admin_comment'] ? 1 : 0;
        let announcement = el['_announcement_id']
          ? el['_announcement_id'].title
          : '';
        let userName = el['_user_id'] ? el['_user_id'].name : '';
        var line =
          announcement +
          ',' +
          userName +
          ',' +
          el['comment'] +
          ',' +
          el['created_ts'] +
          ',' +
          adminReply +
          '\n';
        csv += line;
      });
      var blob = new Blob([csv], { type: 'csv/plain' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Comments.csv';
      link.click();
    },

    downloadLikesCSV() {
      let csv = '\ufeff' + 'NAME,CODE\n';
      this.items.forEach((el) => {
        var line = el['name'] + ',' + el['code'] + '\n';
        csv += line;
      });
      var blob = new Blob([csv], { type: 'csv/plain' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Farms.csv';
      link.click();
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 3.5%;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #454545;
}

.view-icon {
  color: #1da040;
  height: 20px;
  width: 30px;
}

/* Banner specific styles */
.banner-card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border: 1px solid #e3e6f0;
}

.banner-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.banner-image-container {
  position: relative;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
}

.banner-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}

.banner-type-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 0.75rem;
}

.banner-status-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 0.75rem;
}

.banner-content {
  padding: 1rem;
}

.banner-author {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.25rem;
}

.banner-designation {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.banner-quote {
  font-style: italic;
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
}

.banner-url {
  font-size: 0.875rem;
}

.banner-url a {
  color: #007bff;
  text-decoration: none;
}

.banner-url a:hover {
  text-decoration: underline;
}

.banner-actions {
  border-top: 1px solid #e9ecef;
  padding-top: 0.75rem;
}

/deep/ .dataTable thead {
  background-color: #dcffd9;
  height: 64px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: 'Poppins', sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
  color: #303030;
}

/deep/ .dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable tr td {
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>